import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ProjectDetailTabService } from 'src/app/core/services/projectDetailTab.service';
import { Router } from "@angular/router";
import { HttpService } from "../../../../core";
import { environment } from "../../../../../environments/environment";
import { EoiDetailDialog } from "./eoi-detail-dialog/eoi-detail-dialog"
import { AddEoiDialog } from "./add-eoi-dialog/add-eoi-dialog"

@Component({
    selector: 'app-project-detail-eois',
    templateUrl: './eois.component.html',
    styleUrls: ['./eois.component.scss']
})
export class EoisComponent implements OnInit {
    SERVER_URL = environment.SERVER_URL;
    @Input() project: any;
    eoi: string = "eoi";
    eoiDetail: any;
    selected = 'any';
    selectList: any[] = ['any', 'Approved', 'Rejected', 'Pending', 'Withdraw', 'Submit date', 'Approval date'];
    layout = 'grid';
    // 测试数据
    dataSource = [
        {
            id: 1,
            no: 'EoI 1',
            submitTime: 1654704000000,
            agency: 'Agency 1',
            agent: 'Agent 1',
            buyer: 'Buyer 1',
            status: 0,
            processDate: 1654704000000,
        },
        {
            id: 1,
            no: 'EoI 2',
            submitTime: 1654704000000,
            agency: 'Agency 2',
            agent: 'Agent 2',
            buyer: 'Buyer 2',
            status: 1,
            processDate: 1654704000000,
        },
        {
            id: 1,
            no: 'EoI 3',
            submitTime: 1654704000000,
            agency: 'Agency 3',
            agent: 'Agent 3',
            buyer: 'Buyer 3',
            status: 2,
            processDate: 1654704000000,
        },
    ];
    displayedColumns = ['no', 'agency', 'agent', 'buyer', 'status', 'processDate','operation'];

    eoiList: any[] = [];
    total: number;
    page: number = 0;
    pageSize: number = 10;

    submitBeginDate: Date;
    submitEndDate: Date;
    approvalBeginDate: Date;
    approvalEndDate: Date;
    formData: any = {
        eoiNoOrBuyer: null,
        status: '1',
        submitBeginDate: null,
        submitEndDate: null,
        approvalBeginDate: null,
        approvalEndDate: null
    };
    eoiListPendingLength: 0;
    eoiListApprovedLength: 0;
    eoiListAllLength: 0;

    constructor(
        private httpService: HttpService,
        public tabService: ProjectDetailTabService,
        private dialog: MatDialog,
    ) {
    }


    ngOnInit(): void {
        this.getTableData()
        // debugger
        // 获取pending状态数据条数
        this.httpService.pagedListEois(this.project.id, 0, 10, { status: '1' }).toPromise().then((res: any) => {
            console.log(res.data.totalElements)
            this.eoiListPendingLength = res.data.totalElements;
        })
        // 获取approved状态数据条数
        this.httpService.pagedListEois(this.project.id, 0, 10, { status: '2' }).toPromise().then((res: any) => {
            console.log(res.data.totalElements)
            this.eoiListApprovedLength = res.data.totalElements;
        })
        // 获取all状态数据条数
        this.httpService.pagedListEois(this.project.id, 0, 10, { status: null }).toPromise().then((res: any) => {
             console.log(res.data.totalElements)
            this.eoiListAllLength = res.data.totalElements;
        })
    }

    selectedTabChange(index) {
        this.page = 0
        this.formData = {
            eoiNoOrBuyer: null,
            submitBeginDate: null,
            submitEndDate: null,
            approvalBeginDate: null,
            approvalEndDate: null
        };
        if (index == 0) {
            this.formData.status = '1'
        }
        if (index == 1) {
            this.formData.status = '2'
        }
        if (index == 2) {
            this.formData.status = null
        }
        this.getTableData()
    }

    getTableData() {
    
        if (this.tabService.eoiIndex == 0) {
            this.formData.status = '1'
        }
        if (this.tabService.eoiIndex == 1) {
            this.formData.status = '2'
        }
        if (this.tabService.eoiIndex == 2) {
            this.formData.status = null
        }
        this.httpService.pagedListEois(this.project.id, 0, 10, this.formData).toPromise().then((res: any) => {
            console.log('eoiList', res.data.content)
            this.eoiList = res.data.content
            this.page = res.data.number;
            this.pageSize = res.data.size;
            this.total = res.data.totalElements;
        })
    }

    openEoiDetail(eoi) {
        console.log('eoi', eoi)
        // this.eoi = "detail";
        // this.eoiDetail = eoi;
        const dialogRef = this.dialog.open(EoiDetailDialog, {
            width: '700px',
            disableClose: true,
            data: {
                eoiId: eoi.id
            }
        });

        dialogRef.afterClosed().subscribe((result: any) => {
            if (result) {
                this.ngOnInit()
            }
        });
    }

    closeDetail() {
        this.eoi = "eoi";
        this.ngOnInit()
    }

    closeAdd(isRefresh) {
        this.eoi = "eoi";
        console.log(isRefresh,'isRefresh')
        if (isRefresh) {
            this.ngOnInit()
        }
    }

    addEoi() {
        // this.eoi = "add"
        console.log(222222)
        const dialogRef = this.dialog.open(AddEoiDialog, {
            width: '60%',
            disableClose: true,
        });

        dialogRef.afterClosed().subscribe((result: any) => {
            
            this.ngOnInit()
        });
    }

    getData(e) {
        const status = e.status ? e.status : this.formData.status
        this.formData = e
        this.formData.status = status
        this.getTableData()
    }

    getPageData(e) {
        this.httpService.pagedListEois(this.project.id, e ? e.pageIndex : 0, e ? e.pageSize : 10, this.formData).toPromise().then((res: any) => {
            this.eoiList = res.data.content
            this.page = res.data.number;
            this.pageSize = res.data.size;
            this.total = res.data.totalElements;
        })
    }
}
